module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Arrows-638b05c058840b5f0a7198189aa9fa7e.svg";